import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from '@/assets/languages/zh/index'
import en from '@/assets/languages/en/index'
import { getCookie, delCookie, setCookie } from '@/utils/cookie';

Vue.use(VueI18n)
// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: getCookie("languageType") ? getCookie("languageType") : 'en',
  messages: {
    'zh': zh,
    'en': en
  }
})

export default i18n